import cn from 'classnames'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Link from '../common/util/input/Link'
import { MintInfo } from '../mintinfo/MintInfo'
import CollectionHeader from './CollectionHeader'
import config from '../../config.json'
import { formatWAX } from '../helpers/FormatLinks'

function MiniAssetPreview(props) {
    const asset =
        props['asset'] && props['asset']['asset']
            ? props['asset']['asset']
            : props['asset']

    const amountToSell = props['amountToSell']

    const { t } = useTranslation('common')

    const { collection, name, image, mint, assetId, video, newPrice } = asset

    const thumbnail = config.ipfspreviewhash
        .replace('{collection}', collection.collectionName)
        .replace('{size}', 240)
        .replace('{hash}', video ? video : image)

    const { collectionName, verification } = collection

    useEffect(() => {}, [])

    let mintInfo = mint ? (
        <MintInfo mint={mint} small={true} />
    ) : amountToSell ? (
        <div>{amountToSell}x</div>
    ) : (
        ''
    )

    return (
        <div
            className={cn(
                'w-48 relative',
                'text-center text-xs break-words h-fit',
                'mx-0 ',
            )}
        >
            <div
                className={cn(
                    'relative w-full flex flex-wrap flex-col justify-center',
                )}
            >
                <div
                    className={cn(
                        'flex w-48 h-48 aspect-1 bg-gradient-to-b from-page over-page to-transparent  rounded-t-lg',
                    )}
                >
                    <img
                        className={cn('m-auto h-full object-contain')}
                        src={thumbnail}
                    />
                    <div className="absolute top-2 left-2 w-full">
                        {mintInfo}
                    </div>
                </div>
                <div className="mx-2 mt-2">
                    <CollectionHeader
                        author={collectionName}
                        verified={verification}
                    />
                    <div
                        className={cn(
                            'w-full font-bold text-sm',
                            'my-2 pb-2 dark:text-white text-black line-clamp-3',
                        )}
                    >
                        <Link href={'/asset/' + assetId}>
                            <p className="cursor-pointer mt-2">
                                {name
                                    ? name.length > 20
                                        ? name.substring(0, 20) + '...'
                                        : name
                                    : assetId}
                            </p>
                        </Link>
                        <p className="cursor-pointer mt-2">
                            {formatWAX(newPrice)}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MiniAssetPreview
